;(function ($) {
	// eslint-disable-next-line no-unused-vars
	$.fn.dropDownMenu = function (options) {
		if (1024 <= window.innerWidth) {
			const main_menu = $(this)

			$.each(main_menu.find('> li'), function (index, item) {
				// If top level nav item add class top-level
				// to be used later to figure out what is a
				// top level item
				$(item).addClass('top-level')
			})

			main_menu.superfish({
				delay: 500,
				speed: 100,
				onShow: function () {
					const dropdown = $(this)
					const offset = dropdown.offset()
					const left = offset.left
					const width = dropdown.width()
					const docWidth = $(window).width()

					if (!width) return

					const isEntirelyVisible = left + width <= docWidth

					if (!isEntirelyVisible) {
						dropdown.addClass('out-of-bounds')
					}
				},
			})
		}
	}
})(jQuery)
